export const createSelectOptions = (bloodbanks) => {
    const options = bloodbanks.map((item) => {
      return {
        label: item.bloodbankName,
        value: item.bloodbankId,
        disabled: false
      };
    });
    return options;
  };